<div id="copyrightDiv">Copyright {{ currentYear }} Cvent Inc. All rights reserved.
    <a href="https://www.cvent.com/en/privacy-policy" target="_blank">Privacy Policy</a> |
    <a href="https://www.cvent.com/en/product-terms-of-use" target="_blank">Terms of Use</a>
</div>
